// import React from "react"
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


// import PickupDate from '../../../assets/images/pickup-date.png';
// import BookYourCar from '../../../assets/images/book-your-car.png';

//for redux and saga
import { connect } from 'react-redux';
import { getAboutUsContent } from '../../../redux/actions'


const AboutUsContent = (props) => {
  const { getAboutUsContentAction, getAboutUsContentList, loading, error, messages } = props

  console.log("check---", getAboutUsContentList, loading, error, messages);

  React.useEffect(() => {
    // alert('calld')
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  function fetchData() {
    getAboutUsContentAction(1);
  }

  /*const getAboutUsContentList = useSelector((state) => state.distance)
  const brandList = useSelector((state) => state.brand)

  const dispatchDistance = useDispatch()
  const dispatchBrand = useDispatch()

  React.useEffect(() => {
    dispatchBrand(fetchBrand()) //dispatching action one
    dispatchDistance(fetchDistance()) //dispatching action 2
  }, [])

  const [form] = Form.useForm()

  const onFinish = (values) => {
    console.log(values)
    props.onSubmitForm(values)
    form.resetFields()
    console.log(brandList.brand)
    console.log(distanceList.distance)
    // dispatch(fetchBrand);
    // dispatch(fetchDistance);
  }*/

  const regex = /(<([^>]+)>)/ig;
  const secondRegEx = /((&nbsp;))*/gmi;
  return (
    <>
    { getAboutUsContentList.length > 0
      ?
        <section>
          <Container>
            <div className="service">
              <Row>

              { getAboutUsContentList && getAboutUsContentList.map((item) => (
                <Col>
                  <div className="service-content-wrap">
                    <div className="info fw-bold">{item.Title}</div>
                    <div className="detail ">
                    <p>{item.Content.replace(regex, '').replace(secondRegEx,'')}</p>
                    </div>
                  </div>
                </Col>
              ))}
                
              </Row>
            </div>
          </Container>
        </section>
        :<section>

        </section>
      }
      </>
  );

}

//   export default HowitWork;
const mapStateToProps = ({ aboutuscontent }) => { 
  // console.log('======', howitwork);
  const { loading, error, messages, getAboutUsContentList } = aboutuscontent;
  return { loading, error, messages, getAboutUsContentList };
};

export default connect(mapStateToProps, {
  getAboutUsContentAction: getAboutUsContent,
})(AboutUsContent);


